<app-banner [links]="bannnerLinks"></app-banner>

<div class="container mx-auto px-4 py-8">
  @if (loading) {
  <div class="flex justify-center items-center min-h-[400px]">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
  } @else if (error) {
  <div class="text-red-500 text-center">{{ error }}</div>
  } @else if (pharmacy) {
  <!-- Pharmacy Info Header -->
  <div class="bg-white rounded-lg p-4 mb-6 flex items-start gap-4">
    <!-- Avatar -->
    <div class="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
      <lucide-icon [img]="BuildingIcon" color="gray" [size]="18"></lucide-icon>
    </div>

    <!-- Pharmacy Info -->
    <div class="flex-1">
      <div class="flex flex-wrap items-center gap-2">
        <h4 class="text-[14px] font-medium text-gray-900">
          {{ pharmacy?.name }}
        </h4>

        <!-- Prestataire Connecté indicator -->
        @if (pharmacy.eyoneUser) {
        <div class="flex items-center gap-1"
          [title]="'Ce prestataire échange automatiquement vos informations avec votre {{ getProductName() }} pour faciliter votre prise en charge.'">
          <span
            class="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded flex items-center gap-1 whitespace-nowrap">
            <lucide-icon [img]="CircleIcon" [size]="10" class="fill-green-500 text-green-500"></lucide-icon>
            Prestataire Connecté
          </span>
        </div>
        }
      </div>

      <!-- Add Languages section -->
      @if (pharmacy?.languages?.length > 0) {
      <div class="flex items-center gap-2 mt-1">
        <span class="text-[13px] text-gray-600 font-medium">Langues:</span>
        <p class="text-[13px] text-gray-600">
          @for (lang of pharmacy.languages; track $index; let last = $last) {
          {{ lang.name }}@if (!last) {, } }
        </p>
      </div>
      }

      <!-- Contact Info -->
      <div class="mt-3 space-y-1.5">
        @if (pharmacy.coordonate?.email) {
        <div class="flex items-center gap-2 text-gray-600">
          <lucide-icon [img]="MailIcon" color="gray" [size]="14"></lucide-icon>
          <span class="text-[13px]">{{ pharmacy.coordonate.email }}</span>
        </div>
        } @if (pharmacy.coordonate?.mobileNumber ||
        pharmacy.coordonate?.fixNumber) {
        <div class="flex items-center gap-2 text-gray-600">
          <lucide-icon [img]="PhoneIcon" color="gray" [size]="14"></lucide-icon>
          <span class="text-[13px]">
            @if (pharmacy.coordonate?.mobileNumber) {
            {{ pharmacy.coordonate.mobileNumber }}
            } @if (pharmacy.coordonate?.mobileNumber &&
            pharmacy.coordonate?.fixNumber) { &nbsp;/&nbsp; } @if
            (pharmacy.coordonate?.fixNumber) {
            {{ pharmacy.coordonate.fixNumber }}
            }
          </span>
        </div>
        }
      </div>

      <div class="flex flex-col gap-1.5 mt-2">
        <div class="flex items-center gap-2">
          <lucide-icon [img]="ClockIcon" color="gray" [size]="14"></lucide-icon>
          <span class="text-gray-600 text-[13px]">
            {{ pharmacy.openingTH ? "Ouvert 24H/24" : "Horaires standards" }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <lucide-icon [img]="CalendarIcon" color="gray" [size]="14"></lucide-icon>
          <span class="text-gray-600 text-[13px]">
            {{
            pharmacy.openSunday
            ? "Ouvert les dimanches"
            : "Fermé les dimanches"
            }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Details Grid -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
    <!-- Left Column - Details -->
    <div class="lg:col-span-2 space-y-6">
      <!-- Insurance & Payment -->
      <div class="bg-white rounded-lg p-6">
        <div class="grid grid-cols-2 gap-6">
          <!-- Insurers -->
          <div>
            <h5 class="text-[13px] font-medium text-primary mb-3">
              Organismes de remboursement acceptés
            </h5>
            @if (pharmacy.insurers?.length) {
            <div class="space-y-1.5">
              @for (insurer of pharmacy.insurers; track insurer.id) {
              <div class="text-gray-600 text-[13px]">{{ insurer.name }}</div>
              }
            </div>
            } @else {
            <div class="text-gray-400 text-[13px] italic">
              Aucune information disponible
            </div>
            }
          </div>

          <!-- Payment Methods -->
          <div>
            <h5 class="text-[13px] font-medium text-primary mb-3">
              Moyens de paiement acceptés
            </h5>
            @if (pharmacy.paymentTypes?.length) {
            <div class="space-y-1.5">
              @for (payment of pharmacy.paymentTypes; track payment.id) {
              <div class="text-gray-600 text-[13px]">{{ payment.name }}</div>
              }
            </div>
            } @else {
            <div class="text-gray-400 text-[13px] italic">
              Aucune information disponible
            </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column - Map -->
    <div class="lg:col-span-1">
      <div class="bg-white rounded-lg p-6">
        <h5 class="text-md font-medium text-primary mb-3">
          Adresse et localisation
        </h5>
        @if (pharmacy.coordonate?.globalAddressField) {
        <p class="text-gray-600 mb-4">
          {{ pharmacy.coordonate.globalAddressField }}
        </p>
        }
        <div class="h-[300px] rounded-lg overflow-hidden">
          <app-safe-maps [latitude]="pharmacy.coordonate?.latitude ?? 0"
            [longitude]="pharmacy.coordonate?.longitude ?? 0" [zoom]="15">
          </app-safe-maps>
        </div>
      </div>
    </div>
  </div>
  }
</div>